angular.module('cfn').controller('seedPlanningSeedPopupController', [
  '$scope',
  '$log',
  'seedPlanningModel',
  function($scope, $log, seedPlanningModel) {
    var gridCtrl;
    var onShow = function() {
      var seedsPromise = seedPlanningModel.loadSeeds();
      seedsPromise.then(function(seeds) {
        $scope.seeds = seeds;
      });
    };

    /**
     * The grid is ready
     */
    $scope.onGridInit = function(gridController, gridScope) {
      gridCtrl = gridController;
      $scope.gridScope = gridScope;
    };

    /**
     * An item has been selected
     */
    $scope.onSelected = function() {
      var selectedItems = gridCtrl.getSelectedRows();
      var resultFuncName = ang.getInParents($scope, 'tt_result');

      ang.callInParents($scope, resultFuncName)(selectedItems);

      gridCtrl.clearSelection();
      $scope.close();
    };

    /**
     * Double click a row to select
     */
    $scope.onRowDblClick = function(rowData, rowIndex, args) {
      $scope.onSelected();
    };

    /**
     * Close the popup
     */
    $scope.close = function() {
      ang.callInParents($scope, 'closePopover')();
    };

    // Register a handler that is called when dialog is shown
    ang.callInParents($scope, 'registerShowTooltipHandler')(onShow);
  }
]);
